

import React, { useState } from 'react';
import { Form, Spin, Button, Input, InputNumber } from 'antd';

import {
  CardNumberElement,
  CardCVCElement,
  CardExpiryElement
} from 'react-stripe-elements';

const onFinish = ({
  form,
  values,
  props,
  stripeElementErrorMessages,
  setElementErrorMessage,
  campaignId,
  cardNumberRef,
  cvcRef,
  expiryRef
}) => {
  const { stripe, payWithCard, initializeTokenGeneration, getCampaignDetails } = props;

  initializeTokenGeneration(true);
  stripe.createToken().then((response) => {
    if (response && response.error) {
      const code = response.error.code.includes('number') ? 'INVALID_CARD_NUMBER' : (response.error.code.includes('cvc') ? 'INVALID_CVC' : 'INVALID_EXPIRY_DATE')
      const errors = [...stripeElementErrorMessages, {
        code,
        message: response.error.message
      }]
      setElementErrorMessage(errors);
      initializeTokenGeneration(false);
    } else {
      initializeTokenGeneration(false);
      const { amount, first_name, phone_number, last_name, email } = values;
      payWithCard({
        token: response.token.id,
        amount,
        first_name,
        last_name,
        email,
        phone_number,
        campaignId
      }).then(() => {
        getCampaignDetails(campaignId);
        cardNumberRef.clear();
        expiryRef.clear();
        cvcRef.clear();

        form.resetFields();
      }).catch(() => {
        cardNumberRef.clear();
        expiryRef.clear();
        cvcRef.clear();

        form.resetFields();
      })
    }
  }).catch((err) => {
    console.log('IN THE CATCH OF token', err);
  });
};

const onFinishFailed = (error) => {
  console.log('Failed:', error);
};

// const getErrorMessagesForStripeElements = (stripeErrors) => {
//   let cardNumberMessage = '';
//   let expiryDateMessage = '';
//   let cvcCheckMessage = '';
//   stripeErrors && stripeErrors.forEach(({ code, message }) => {
//     if (code === 'INVALID_CVC') {
//       cvcCheckMessage = message;
//     } else if (code === 'INVALID_CARD_NUMBER') {
//       cardNumberMessage = message
//     } else {
//       expiryDateMessage = message;
//     }
//   });

//   return {
//     cvcCheckMessage,
//     cardNumberMessage,
//     expiryDateMessage
//   };
// };

const CardPayment = (props) => {
  const [stripeElementErrorMessages, setElementErrorMessage] = useState([]);
  const [cardNumberRef, setCardNumberRef] = useState(null);
  const [cvcRef, setCvcRef] = useState(null);
  const [expiryRef, setExpiryRef] = useState(null);

  const { donateMoney, campaignId } = props;
  const { loadingForDonateMoney } = donateMoney;
  // const { cardNumberMessage, expiryDateMessage, cvcCheckMessage } = getErrorMessagesForStripeElements(stripeElementErrorMessages);
  const [form] = Form.useForm();

  return (
    <div>
      <Spin spinning={loadingForDonateMoney}>
        <Form
          name="basic"
          form={form}
          onFinish={(values) => onFinish({
            form,
            values,
            props,
            stripeElementErrorMessages,
            setElementErrorMessage,
            campaignId,
            cardNumberRef,
            cvcRef,
            expiryRef
          })}
          onFinishFailed={onFinishFailed}
        >
          <div className="form-row">
            <div className="form-group col-sm-6">
              <Form.Item
                name="amount"
                rules={[
                  {
                    required: true,
                    message: 'Please input a valid amount!',
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: '100%' }} placeholder='Enter amount' />
              </Form.Item>
            </div>
            <div className="form-group col-sm-6">
              <Form.Item
                name="form_card_number"
                rules={[
                  {
                    required: true,
                    message: 'Please input your card number!',
                  },
                ]}
              >
                <CardNumberElement
                  style={{ height: '58px' }}
                  onReady={e => setCardNumberRef(e)}
                  placeholder='Card Number (e.g. 1234 1234 1234 1234)'
                  onChange={(value) => {
                    const { error } = value;
                    if (error && error.code) {
                      const errors = [...stripeElementErrorMessages, {
                        code: 'INVALID_CARD_NUMBER',
                        message: error.message
                      }]
                      setElementErrorMessage(errors);
                    } else {
                      const errors = stripeElementErrorMessages.filter(({ code }) => code !== 'INVALID_CARD_NUMBER');
                      setElementErrorMessage(errors);
                    }
                  }}
                />
              </Form.Item>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6">
              <Form.Item
                name="form_card_nuDASmber"
                rules={[
                  {
                    required: true,
                    message: 'Please input your CVC!',
                  },
                ]}
              >
                <CardCVCElement
                  onReady={e => setCvcRef(e)}
                  onChange={(value) => {
                    const { error } = value;
                    if (error && error.code) {
                      const errors = [...stripeElementErrorMessages, {
                        code: 'INVALID_CVC',
                        message: error.message
                      }]
                      setElementErrorMessage(errors);
                    } else {
                      const errors = stripeElementErrorMessages.filter(({ code }) => code !== 'INVALID_CVC');
                      setElementErrorMessage(errors);
                    }
                  }}
                />
              </Form.Item>
            </div>
            <div className="form-group col-sm-6">
              <Form.Item
                name="form_card_ndasuDASmber"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Expiry!',
                  },
                ]}
              >
                <CardExpiryElement
                  onReady={e => setExpiryRef(e)}
                  placeholder='Card Expiry Date (MM / YY)'
                  onChange={(value) => {
                    const { error } = value;
                    if (error && error.code) {
                      const errors = [...stripeElementErrorMessages, {
                        code: 'INVALID_EXPIRY_DATE',
                        message: error.message
                      }]
                      setElementErrorMessage(errors);
                    } else {
                      const errors = stripeElementErrorMessages.filter(({ code }) => code !== 'INVALID_EXPIRY_DATE');
                      setElementErrorMessage(errors);
                    }
                  }}
                />
              </Form.Item>

            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6">
              <Form.Item
                name="first_name"
                rules={[
                  {
                    required: true,
                    message: 'Please input your first name!',
                  },
                ]}
              >
                <Input style={{ width: '100%' }} placeholder='First Name' />
              </Form.Item>
            </div>
            <div className="form-group col-sm-6">
              <Form.Item
                name="last_name"
                rules={[
                  {
                    required: true,
                    message: 'Please input your last name!',
                  },
                ]}
              >
                <Input style={{ width: '100%' }} placeholder='Last Name' />
              </Form.Item>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6">
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please input your email!',
                  },
                ]}
              >
                <Input type='email' style={{ width: '100%' }} placeholder='Email' />
              </Form.Item>
            </div>
            <div className="form-group col-sm-6">
              <Form.Item
                name="phone_number"
                rules={[
                  {
                    required: true,
                    message: 'Please input your phone number!',
                  },
                ]}
              >
                <Input style={{ width: '100%' }} placeholder='Phone Number' />
              </Form.Item>
            </div>
          </div>
          <div className="form-row d-flex justify-content-between m-0">
            <div className="form-group">
              {/* <a href='/homepage' className="btn btn-outline-dark btn-block" style={{ height: '48px', padding: '10px 10px' }}>
                <svg id="arrow-right-line_4_" data-name="arrow-right-line (4)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path id="Path_5" data-name="Path 5" d="M24,0H0V24H24Z" fill="none" />
                  <path id="Path_6" data-name="Path 6" d="M7.828,11l5.364-5.364L11.778,4.222,4,12l7.778,7.778,1.414-1.414L7.828,13H20V11Z" />
                </svg>
              </a> */}
            </div>
            <div className="form-group">
              <Form.Item>
                <Button className="btn btn-success btn-block" style={{ height: '48px', fontWeight: '500', padding: '10px 30px' }} type="primary" htmlType="submit">
                  Pay Now
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default CardPayment;
